import React, { useState } from 'react';

import { Button } from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import EventRoundedIcon from '@material-ui/icons/EventRounded';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { EmployeeIcon } from 'constants/icons';

import AutoCompleteFilter from './filterTypes/AutoCompleteFilter';
import CustomFilter from './filterTypes/CustomFilter';
import DateFilter from './filterTypes/DateFilter';
import EmployeeFilter from './filterTypes/EmployeeFilter';
import FixedFilter from './filterTypes/FixedFilter';
import SliderFilter from './filterTypes/SliderFilter';

const PluginFilters = ({ filters, selectedFilters, updateFilters, disabled = false, editMetric, removeAllFilters }) => {
  const [isExpanded, setExpanded] = useState(false);

  const toggleIsExpanded = () => setExpanded(!isExpanded);

  const getSelectedFilters = (filter) => selectedFilters[filter] || [];

  const getFilterComponent = (filter, index) => {
    const commonProps = {
      selectedFilters: getSelectedFilters(filter.displayName),
      updateFilters,
      filterName: filter.displayName,
    };
    switch (filter.uiType) {
      case 'MULTI_VALUE_DROP_DOWN':
        return (
          <FixedFilter
            {...commonProps}
            icon={<CheckBoxIcon />}
            filterValues={filter.values.split(',').map((v) => v.trim())}
          />
        );
      case 'EMPLOYEE_LIST':
        return <EmployeeFilter {...commonProps} icon={<EmployeeIcon />} />;
      case 'DATE':
        return <DateFilter {...commonProps} icon={<EventRoundedIcon />} />;
      case 'AMOUNT':
        return <SliderFilter {...commonProps} icon={<AttachMoneyIcon />} index={index} />;
      case 'EMPLOYEE_GRADE':
        return <AutoCompleteFilter {...commonProps} icon={<CheckBoxIcon />} tagType={SEARCH_WIDGET_TYPES.grade} />;
      case 'EMPLOYEE_FUNCTION':
        return <AutoCompleteFilter {...commonProps} icon={<CheckBoxIcon />} tagType={SEARCH_WIDGET_TYPES.function} />;
      case 'COMMA_SEPARATED_VALUES':
      default:
        return <CustomFilter {...commonProps} icon={<CheckBoxIcon />} index={index} />;
    }
  };

  return (
    <Container>
      <StyledTypography variant="body2" color="#999" display="block" bottomGutter={1}>
        Filters / Builder
        <Link>({disabled ? <a onClick={editMetric}>Edit</a> : <a onClick={removeAllFilters}>Clear All</a>})</Link>
      </StyledTypography>

      <FiltersList disabled={disabled}>
        {filters.map((filter, index) => (
          <>{(index < 3 || isExpanded) && getFilterComponent(filter, index)}</>
        ))}

        {filters.length > 3 && (
          <StyledButton
            variant="contained"
            color="primary"
            onClick={toggleIsExpanded}
            endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          >
            <StyledTypography variant="body2" color="#333" display="block">
              {isExpanded ? 'Less' : 'More'}
            </StyledTypography>
          </StyledButton>
        )}
      </FiltersList>
    </Container>
  );
};

const Container = styled.div`
  margin: 1.25rem 0;
`;

const FiltersList = styled.div`
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.3;
  `};
`;

const StyledButton = styled(Button)`
  border-radius: 0px;
  background: white;
  text-transform: initial;
  box-shadow: none;
  font-size: 1rem;
  padding: 0.5rem 0.6rem;
  vertical-align: super;
  &:hover {
    background: white;
    box-shadow: none;
  }
  svg {
    fill: #333;
  }
`;

const Link = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
  a {
    color: #008ef0;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export default PluginFilters;
